import {FC} from "react";
import {motion} from "framer-motion";

interface IBackdrop {
    onClick: () => void,
    initialOpacity?: 0|1
}

const Backdrop:FC<IBackdrop> = ({onClick, initialOpacity = 0}) => {
    return <motion.div
        onClick={onClick}
        className="absolute inset-0 backdrop backdrop-blur-xs"
        initial={{ opacity: initialOpacity }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
    />
}

export default Backdrop;